import { get, ref, update } from "firebase/database";
import { useState } from "react";
import { database } from "../firebase";

const ChangePassword = () => {
  const [form, setForm] = useState({ email: "", oldPassword: "", newPassword: "", confirmPassword: "" });
  const [msg, setMsg] = useState({ text: "", type: "" });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.newPassword !== form.confirmPassword) {
      setMsg({ text: "New passwords do not match.", type: "danger" });
      return;
    }
    setLoading(true);
    try {
      const snapshot = await get(ref(database, "admins"));
      let matched = false;
      snapshot.forEach((child) => {
        const user = child.val();
        if (user.email === form.email && user.password === form.oldPassword) {
          update(ref(database, `admins/${child.key}`), { password: form.newPassword });
          matched = true;
        }
      });
      if (matched) {
        setMsg({ text: "Password changed successfully!", type: "success" });
        setForm({ email: "", oldPassword: "", newPassword: "", confirmPassword: "" });
      } else {
        setMsg({ text: "Email or current password is incorrect.", type: "danger" });
      }
    } catch {
      setMsg({ text: "Something went wrong. Try again.", type: "danger" });
    }
    setLoading(false);
  };

  return (
    <div className="container mt-4" style={{ maxWidth: "480px" }}>
      <h5 className="fw-bold pb-2 mb-4" style={{ borderBottom: '2px solid #90b732', color: '#90b732' }}>Change Password</h5>
      {msg.text && <div className={`alert alert-${msg.type} py-2`}>{msg.text}</div>}
      <div className="card shadow-sm p-4">
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label fw-semibold">Email</label>
            <input type="email" name="email" className="form-control" required
              value={form.email} onChange={handleChange} placeholder="Your admin email" />
          </div>
          <div className="mb-3">
            <label className="form-label fw-semibold">Current Password</label>
            <input type="password" name="oldPassword" className="form-control" required
              value={form.oldPassword} onChange={handleChange} placeholder="Enter current password" />
          </div>
          <div className="mb-3">
            <label className="form-label fw-semibold">New Password</label>
            <input type="password" name="newPassword" className="form-control" required
              value={form.newPassword} onChange={handleChange} placeholder="Enter new password" />
          </div>
          <div className="mb-4">
            <label className="form-label fw-semibold">Confirm New Password</label>
            <input type="password" name="confirmPassword" className="form-control" required
              value={form.confirmPassword} onChange={handleChange} placeholder="Confirm new password" />
          </div>
          <button className="btn w-100" style={{ background: '#90b732', color: '#fff' }} type="submit" disabled={loading}>
            {loading ? "Updating..." : "Change Password"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;
export const ImageManagerFile = ChangePassword;
